import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var progressStyle = function progressStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary = _getThemeData.primary;
  var _getThemeData2 = getThemeData(props, 'circleProgress'),
    execBgColor = _getThemeData2.execBgColor,
    succBgColor = _getThemeData2.succBgColor;
  return css([".c7n-progress-loading.c7n-progress-loading{display:inline-block;&.c7n-progress-status-normal{.c7n-progress-inner circle{stroke:", ";}}&.c7n-progress-status-success{.c7n-progress-inner circle{stroke:", ";}}&.c7n-progress-status-exception{.c7n-progress-inner circle{stroke:", ";}}}"], primary, succBgColor, execBgColor);
};
export default progressStyle;